<template>
  <div v-if="isLocal || isTest" class="fixed bg-primary/80 lg:top-0 right-0 bottom-0 w-6 p-1 z-50 pointer-events-none">
    <WrenchIcon class="w-full aspect-square text-foreground" />
  </div>
</template>
<script setup>
import { isLocal, isTest } from "@/config";
import { WrenchIcon } from "@heroicons/vue/24/outline";
</script>
